module.exports = __webpack_public_path__ + "static/media/Hbook-17.8521e51b.jpg";